import { render, staticRenderFns } from "./SaveSuccess.vue?vue&type=template&id=51d38a45&scoped=true&"
import script from "./SaveSuccess.vue?vue&type=script&lang=js&"
export * from "./SaveSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d38a45",
  null
  
)

export default component.exports